import { render, staticRenderFns } from "./HomeDashboardTile.vue?vue&type=template&id=db063b58&scoped=true&"
import script from "./HomeDashboardTile.vue?vue&type=script&lang=ts&"
export * from "./HomeDashboardTile.vue?vue&type=script&lang=ts&"
import style0 from "./HomeDashboardTile.vue?vue&type=style&index=0&id=db063b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db063b58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
